import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { Location } from '@/models/location.model';
import { EventSource } from '@/models/event-source.model';
import locationsService from '@/services/locations.service';

export interface LocationsState {
  items: Location[];
  sources: EventSource[];
}

export enum LocationsMutations {
  SetLocations = 'go/SetLocations',
}

export enum LocationsActions {
  GetLocation = 'los/GetLocation',
  GetLocations = 'los/GetLocations',
  AddLocation = 'los/AddLocation',
  UpdateLocation = 'los/UpdateLocation',
  DeleteLocation = 'los/DeleteLocation',
}

const sn = (str: LocationsActions | LocationsMutations): string =>
  str.replace(/los\//g, '');

export const locationsStore: Module<LocationsState, ShiftCMSState> = {
  namespaced: true,
  state: {
    items: [],
    sources: [],
  },
  mutations: {
    [sn(LocationsMutations.SetLocations)](state, items: Location[]) {
      state.items = items;
    },
  },
  actions: {
    async [sn(LocationsActions.GetLocation)](_, id) {
      const res = await locationsService.get(id);
      if (res.status) {
        return res.data;
      }
    },
    async [sn(LocationsActions.GetLocations)]({ commit }) {
      const res = await locationsService.getList();
      if (res.status) {
        commit(sn(LocationsMutations.SetLocations), res.data);
      }
    },
    async [sn(LocationsActions.AddLocation)]({ dispatch }, item: Location) {
      const res = await locationsService.create(item);
      if (res.status) {
        dispatch(sn(LocationsActions.GetLocations));
      }

      return res.status;
    },
    async [sn(LocationsActions.UpdateLocation)]({ dispatch }, item: Location) {
      const res = await locationsService.update(item);
      if (res.status) {
        dispatch(sn(LocationsActions.GetLocations));
      }
      return res.status;
    },
    async [sn(LocationsActions.DeleteLocation)]({ dispatch }, id: number) {
      const res = await locationsService.delete(id);

      if (res.status) {
        dispatch(sn(LocationsActions.GetLocations));
      }
    },
  },
};
